import { useContext } from "react";

import { DatatableContext, type DatatableContextType } from "./datatable-context/datatable-context";
import { type DatatableRowData } from "./datatable-types";

export const useDatatableContext = <TData extends DatatableRowData>(): DatatableContextType<TData> => {
  const context = useContext(DatatableContext);

  if (!context) {
    throw new Error("useDataTableContext must be used within a DataTableContextProvider");
  }

  return context as DatatableContextType<TData>;
};

export const useUnsafeDatatableContext = <TData extends DatatableRowData>(): DatatableContextType<TData> | null => {
  return useContext(DatatableContext) as DatatableContextType<TData> | null;
};
